module.exports = __webpack_public_path__ + "static/media/construction-sign_1f6a7.acd04887.png";